import { BaseResponseSchema } from '@server/schemas'

export type CheckCouponForPaymentResponse = BaseResponseSchema<boolean>

export * from './coupon.model'
